import React from 'react';
import { Switch } from 'antd';

const PresenceOfficeSwitch = (props) => (
  <div className="le-presence-office-switch">
    LE Presence
    <Switch {...props} />
    Offices
  </div>
);

export default PresenceOfficeSwitch;
